import React from 'react';
import { Variant } from '../types';
import { Manage } from '../../components/navigation/Manage';
import { Develop } from '../../components/navigation/Develop';
import { Partner } from '../../components/navigation/Partner';
import { UserMenu } from '../../components/user-menu';

const apps: Variant = {
  title: 'App Directory',
  getMenuItems: (): JSX.Element[] => {
    return [
      <Manage key="menu-manage" />,
      <Develop key="menu-developer" />,
      <Partner key="menu-partner" />,
    ];
  },
  actions: [],
  info: [],
  user: [<UserMenu key="menu-user" />],
  homePage: '/apps/',
};

export default apps;
